import { render, staticRenderFns } from "./TechSolution.vue?vue&type=template&id=095fc6ce&"
import script from "./TechSolution.vue?vue&type=script&lang=js&"
export * from "./TechSolution.vue?vue&type=script&lang=js&"
import style0 from "./TechSolution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports